import {
	Component, Input, Output, EventEmitter, SimpleChanges, ViewChild, 
	 ChangeDetectorRef
} from '@angular/core';
import { ViewerDeviceGroupDto } from "UvExplorerServer.Dtos.TS/Viewer";
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { DeviceGroupComponent } from '../../device-group/device-group.component';
import { MessageService } from 'base';
import { DiscResultsService } from 'discovery';
import {
  DisplayDeviceGroupDto
} from 'UvExplorerServer.Dtos.TS/Session';
import { IdentityService } from 'identity';
import { DevicesComponent } from '../../devices/devices.component';

@Component({
    selector: 'device-group-dialog',
	templateUrl: './device-group-dialog.component.html'
})
export class DeviceGroupDialogComponent {

	@Input()
	public visible: boolean;

	@Input()
	public target: ViewerDeviceGroupDto;

	@Input()
	public network: NetViewDto;

	@Input()
	public devicesComponent: DevicesComponent;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<any>;

	@Output()
	public onCancel: EventEmitter<any>;

    @ViewChild(DeviceGroupComponent, { static: true })
	public deviceGroup: DeviceGroupComponent;

	public get enableOk(): boolean {
		return this.deviceGroup.enableApply;
	}

	constructor(private discResultsService: DiscResultsService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef,
		private identityService: IdentityService) {

		this.visible = false;
		this.target = null;
		this.network = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}

	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public onDialogHide(): void {
		this.hide();
		this.onCancel.emit();
	}

	public onCancelClicked(): void {
		this.deviceGroup.discardTempChanges();
		this.hide();
		this.onCancel.emit();
	}

	private get sessionGuid(): string {
		return this.identityService.sessionGuid;
	}

	private get netViewGuid(): string {
		return (this.network ? this.network.Guid : "");
	}

	public onOkClicked(): void {
		if (this.target) {
			this.deviceGroup.applyTempChanges();

			let errorMessage = "Device group save failed";
			this.discResultsService.updateDeviceGroup(this.sessionGuid, this.target).subscribe(
				(result: DisplayDeviceGroupDto) => {
					// ???
					//this.devicesComponent.rebuildCustomGroupTree();
				},
				(error: any) => {
					this.messageService.displayErrorMessage(errorMessage);
				});
		}

		this.hide();
		this.onOk.emit();
	}

	public ngOnChanges(changes: SimpleChanges): void {

		if (changes["target"]) {
		}

	}

	public detectChanges(): void {
		this.changeDetector.detectChanges();
	}

}
